const new_api_url: string = "https://api.clubready.com";
export const get_tokens_url: string = `${new_api_url}/security/v1/token`;
export const get_auth_token_url: string =
  "https://piq-api.myperformanceiq.com/el/gt";
export const send_cr_request_url: string =
  "https://piq-api.myperformanceiq.com/el/send-cr-request";
export const piq_widget: string = "https://piq-api.myperformanceiq.com/widgets";
export const piq_api_url = "https://piq-api.myperformanceiq.com/piq-api/Test";

export const apis: any = {
  get_user_by_id: {
    type: "new",
    url: `${new_api_url}/users/v1/users/{UserId}`,
  },
  get_user_agreements: {
    type: "new",
    url: `${new_api_url}/sales/v1/users/agreements?StoreId={StoreId}&UserId={UserId}&PageSize=1000`,
  },
  get_package: {
    type: "new",
    url: `${new_api_url}/sales/v1/clubs/{ClubId}/packages/{PackageId}`,
  },
  cancel_agreement_on_future_date: {
    type: "new",
    url: `${new_api_url}/sales/v1/agreements/{AgreementId}/cancel/{CancellationDate}?CancelledById={CancelledById}&CancelNote={CancelNote}&CancellationReason=131`,
  },
  cancel_agreement: {
    type: "new",
    url: `${new_api_url}/sales/v1/agreements/{AgreementId}/cancel?CancelledById={CancelledById}&CancelNote={CancelNote}&CancellationReason=131`,
  },
  click_to_cancel_login: {
    type: "new",
    url: `${new_api_url}/security/v1/clubs/{clubId}/users/click-to-cancel/login`,
  },
  get_club: {
    type: "new",
    url: `${new_api_url}/clubs/v1/clubs/{clubId}`,
  },
};
